import { useQuery } from '@tanstack/react-query'
import type { Cluster } from '../../types/cluster'
import api from '../../api'

const useClusters = () => {
	return useQuery({
		queryKey: ['clusters'],
		queryFn: () => api.clusters.getClusters(),
		retry: false,
		select(data) {
			return (data?.body ?? []) as Array<Cluster>
		}
	})
}

export default useClusters
